import { request } from '../api.js';

export interface AlertListItem {
  id: string;
  type: 'LOW_BALANCE' | 'BUDGET_OVERSPEND' | 'MONTHLY_CLOSING' | 'ANOMALY';
  severity: 'INFO' | 'WARNING' | 'CRITICAL';
  fundId: string | null;
  fundCode: string | null;
  fundName: string | null;
  message: string;
  isRead: boolean;
  triggeredAt: string;
  readAt: string | null;
}

export interface AlertsListOptions {
  isRead?: boolean;
  limit?: number;
}

export function listAlerts(opts: AlertsListOptions = {}): Promise<AlertListItem[]> {
  const params: Record<string, string> = {};
  if (typeof opts.isRead === 'boolean') params.isRead = String(opts.isRead);
  if (opts.limit) params.limit = String(opts.limit);
  return request<AlertListItem[]>('get', '/alerts', undefined, { params });
}

export function getUnreadCount(): Promise<{ unread: number }> {
  return request<{ unread: number }>('get', '/alerts/unread-count');
}

export function markAlertRead(id: string): Promise<{ ok: true }> {
  return request<{ ok: true }>('post', `/alerts/${id}/read`);
}

export function markAllAlertsRead(): Promise<{ updated: number }> {
  return request<{ updated: number }>('post', '/alerts/read-all');
}
